import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

const selectAuth = (state: RootState) => state.auth;

export const selectAuthApi = createSelector(
  [selectAuth],
  ({ apiStatus, session, errorResponse }) => ({
    apiStatus,
    session,
    errorResponse,
  })
);

export const selectSession = createSelector([selectAuth], ({ session }) => ({
  session,
}));

export const selectGuid = createSelector([selectAuth], ({ guid }) => ({
  guid,
}));

export const selectLogin = createSelector(
  [selectAuth],
  ({ guid, session, isLogged, showLogoutPage }) => ({
    guid,
    session,
    isLogged,
    showLogoutPage
  })
);
